export { default as Create } from './Create';
export { default as Edit } from './Edit';
export { default as List } from './List';
export { default as RequiredRole } from './StaticData/RequiredRole';
export { default as Show } from './Show';



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/index.tsx